// Vurderer om et eksternt link risikerer at starte en download i stedet
// for at åbne inline i browseren.
export type LinkIntent = "safe" | "risky";

const RISKY_PATH_HINTS = ["/download", "/attachment", "/dl/", "/fulltext"];
const RISKY_QUERY_HINTS = ["download=", "attachment=", "dl=1", "dl=true"];
const RISKY_EXTENSIONS = [".pdf", ".doc", ".docx", ".epub", ".zip", ".rtf", ".odt", ".mobi", ".xls", ".xlsx", ".ppt", ".pptx"];

export function linkIntent(url: string): LinkIntent {
  try {
    const u = new URL(url);
    const path = u.pathname.toLowerCase();
    const query = u.search.toLowerCase();

    if (RISKY_EXTENSIONS.some((ext) => path.endsWith(ext) || path.includes(ext + "/") || query.includes(ext))) return "risky";
    if (RISKY_PATH_HINTS.some((p) => path.includes(p))) return "risky";
    if (RISKY_QUERY_HINTS.some((p) => query.includes(p))) return "risky";
    if (u.searchParams.get("format") === "pdf" || u.searchParams.get("type") === "pdf") return "risky";
    return "safe";
  } catch {
    return "safe";
  }
}

// Google Docs viewer renderer PDF (og PDF-lignende) filer inline i en ny fane
// i stedet for at starte en download.
export function viewableUrl(url: string): string {
  try {
    return `https://docs.google.com/viewer?url=${encodeURIComponent(url)}`;
  } catch {
    return url;
  }
}
